import "core-js/stable";
import "regenerator-runtime/runtime";
import { Collapse } from 'bootstrap';

import "./js/config.js";
// Load in vendor scripts (loaded by Webpack directly);
import "bootstrap";

// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/native-loading/ls.native-loading';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Load in styles
import "./scss/styles.scss";

import validationService from './js/validationService';

validationService();

const orderProcessing = document.querySelector('.js-order-processing');

if (orderProcessing) {
    setInterval(() => {
        fetch(`/Umbraco/Surface/OrderStatus/Get/?id=${orderProcessing.dataset.id}&pid=${orderProcessing.dataset.pid}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response => {
                if (!response.processing) {
                    window.location = response.url
                }
                else {
                    document.querySelector('.js-processing-message').innerHTML = response.message;
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, 2000);
}

const orderProcessingDonation = document.querySelector('.js-order-processing-donation');

if (orderProcessingDonation) {
    setInterval(() => {
        fetch(`/Umbraco/Surface/OrderStatus/GetDonation/?id=${orderProcessingDonation.dataset.id}&pid=${orderProcessingDonation.dataset.pid}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response => {
                if (!response.processing) {
                    window.location = response.url
                }
                else {
                    document.querySelector('.js-processing-message').innerHTML = response.message;
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, 2000);
}

const orderProcessingMembership = document.querySelector('.js-order-processing-membership');

if (orderProcessingMembership) {
    setInterval(() => {
        fetch(`/Umbraco/Surface/OrderStatus/GetMembership/?id=${orderProcessingMembership.dataset.id}&pid=${orderProcessingMembership.dataset.pid}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(response => {
                if (!response.processing) {
                    window.location = response.url
                }
                else {
                    document.querySelector('.js-processing-message').innerHTML = response.message;
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
    }, 2000);
}


// Conditional dynamic imports

// Webpack will store those modules in separate JS files and
// load them on demand, keeping payload down.


// Load in custom JS modules required on initial page load

import(
    /* webpackFetchPriority: "high" */
    './js/viewport-size'
);

if (document.querySelector('body.site-layout') != null) {
    import('./js/scrolling');
    import('./js/keyboard-accessibility-check');
}

if (document.querySelector('.header--content--menu') != null) {
    import(
        /* webpackMode: "lazy" */
        './js/main-navigation'
    );
}

if (document.querySelector('#header--content--search--show--btn') != null) {
    import(
        /* webpackMode: "lazy" */
        './js/header-search'
    );
}

if (document.querySelector('#checkout-time-remaining') != null) {
    import('./js/checkout-time-remaining');
}

if (document.querySelector('#payment--optional-donation') != null) {
    import(
        /* webpackMode: "lazy" */
        './js/payment-optional-donation'
    );
    import(
        /* webpackMode: "lazy" */
        './js/payment-optional-giftaid'
    );
}

if (document.querySelector('.emergency-message') != null) {
    import(
        /* webpackMode: "lazy" */
        './js/alert-message'
    );
}

if (document.querySelector('#account-logout-form') != null) {
    import('./js/logout-form');
}

// template demos? - page theme changer on header logo click
if(location.hostname === "localhost" || location.hostname.indexOf('templates') > -1) {
    import(
        /* webpackMode: "lazy" */
        './js/templates-theme-changer.js'
    );
}

if (document.querySelector('#checkout-time-remaining') != null) {
    import('./js/checkout-time-remaining');
}

// Load in custom JS modules on initial page load and when DOM is updated

const addDataJsParsed = (elements, tag = '') => {
    elements.forEach(x => {
        x.setAttribute(`data-js-parsed--${tag}`,'');
    });
}

const quickCheckQueries = [];
let quickCheckQueryComplete = false,
    quickCheckQueryString = null;
const addQuickCheckQuery = (s) => {
    if(!quickCheckQueryComplete) {
        quickCheckQueries.push(s);
        quickCheckQueryString = quickCheckQueries.toString();
    }
};
const jsModuleQuickCheck = async () => {
    let checkQuery = document.querySelector(quickCheckQueryString);
    if (checkQuery != null) jsModuleCheck();
};

const jsModuleCheck = async () => {

    let testQueryString = null,
        testQuery = null;

    // accordion open/close all
    testQueryString = '.accordion--open-close-all:not([data-js-parsed--accordion-open-close-all])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "accordion-open-close-all");
        import('./js/accordion-open-close-all').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // collapse - expand for desktop
    testQueryString = '.expand-for-desktop:not([data-js-parsed--expand-for-desktop])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "expand-for-desktop");
        import('./js/collapse-expand-for-desktop').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // list-carousel
    testQueryString = '.list-carousel:not([data-js-parsed--list-carousel])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "list-carousel");
        import('./js/list-carousel').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // smart-bootstrap-tabs
    testQueryString = '.nav[role="tablist"]:not([data-js-parsed--smart-bootstrap-tabs])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "smart-bootstrap-tabs");
        import('./js/smart-bootstrap-tabs').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // defer-iframe-content
    testQueryString = 'iframe.defer-iframe-content[data-src]:not([data-js-parsed--defer-iframe-content])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "defer-iframe-content");
        import(
            /* webpackMode: "lazy" */
            './js/defer-iframe-content'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // height matching
    testQueryString = '*[data-hm-group]:not([data-js-parsed--height-match])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "height-match");
        import('./js/height-match').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hunt-watch
    testQueryString = '.hunt-watch:not([data-js-parsed--hunt-watch])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "hunt-watch");
        import('./js/hunt-watch').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // section--scroll-reveal
    testQueryString = '.section--scroll-reveal:not([data-js-parsed--section--scroll-reveal])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "section--scroll-reveal");
        import('./modules/section-scroll-reveal/section-scroll-reveal.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // reveal
    testQueryString = '.reveal:not([data-js-parsed--reveal])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "reveal");
        import('./js/reveal').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // bg-curves
    testQueryString = '.bg-curves:not([data-js-parsed--bg-curves])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "bg-curves");
        import('./modules/bg-curves/bg-curves.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // non-lazyload img-load-watcher
    testQueryString = 'img.img-load-watcher:not([data-js-parsed--img-load-watcher])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "img-load-watcher");
        import('./js/img-load-watcher').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // image-loader-group
    testQueryString = '.image-loader-group:not([data-js-parsed--image-loader-group])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "image-loader-group");
        import('./js/image-loader-group').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hero video - vimeo
    testQueryString = '.hero--video.vimeo:not([data-js-parsed--vimeo])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "vimeo");
        import(
            /* webpackFetchPriority: "high" */
            './js/hero-video-vimeo'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hero video - youtube
    testQueryString = '.hero--video.youtube:not([data-js-parsed--youtube])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "youtube");
        import(
            /* webpackFetchPriority: "high" */
            './js/hero-video-youtube'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // hero clickable
    testQueryString = '.hero--layout.clickable:not([data-js-parsed--hero-clickable])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "hero-clickable");
        import('./js/hero-clickable').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // lightboxes (PhotoSwipe v5 - galleries and single images)
    testQueryString = '.lightbox-image:not([data-js-parsed--lightbox]), .image-gallery:not([data-js-parsed--lightbox])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "lightbox");
        import(
            /* webpackMode: "lazy" */
            './modules/lightboxes-galleries/lightboxes.js'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // data-sizes-js-fix (fixes lazysizes issue)
    testQueryString = '*[data-sizes-js-fix]:not([data-js-parsed--data-sizes-js-fix])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "data-sizes-js-fix");
        import('./js/data-sizes-js-fix').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // fixed-bg-video
    testQueryString = '.fixed-bg-video:not([data-js-parsed--fixed-bg-video])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fixed-bg-video")
        import('./js/fixed-bg-video').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // responsive nav bar
    testQueryString = '.responsive-nav-bar:not([data-js-parsed--responsive-nav-bar])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "responsive-nav-bar");
        import('./modules/responsive-nav-bar/responsive-nav-bar.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // responsive table
    testQueryString = '.responsive-table:not([data-js-parsed--responsive-table])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "responsive-table");
        import('./modules/responsive-table/responsive-table.js');
    }

    // width-watcher
    testQueryString = '*[data-width-watcher]:not([data-js-parsed--width-watcher])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "width-watcher");
        import('./js/width-watcher').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // panels-swiper
    testQueryString = '.panels-swiper:not([data-js-parsed--panels-swiper])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "panels-swiper");
        import('./js/panels-swiper').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // basic-swiper
    testQueryString = '.basic-swiper:not([data-js-parsed--basic-swiper])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "basic-swiper");
        import('./js/basic-swiper').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // logos-swiper
    testQueryString = '.logos-swiper:not([data-js-parsed--logos-swiper])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "logos-swiper");
        import('./js/logos-swiper').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // testimonials-carousel
    testQueryString = '.testimonials-carousel:not([data-js-parsed--testimonials-carousel])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "testimonials-carousel");
        import('./modules/testimonials-carousel/testimonials-carousel.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // filter-listing (live and static)
    testQueryString = '.filter-listing:not([data-js-parsed--filter-listing])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "filter-listing");
        import('./modules/filter-listing/filter-listing.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // help search form
    testQueryString = '.help-search-form:not([data-js-parsed--help-search-form])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "help-search-form");
        import(
            /* webpackMode: "lazy" */
            './js/help-search-form'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // collection search form
    testQueryString = '.collection-search-form:not([data-js-parsed--collection-search-form])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "collection-search-form");
        import(
            /* webpackMode: "lazy" */
            './js/collection-search-form'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // media-gallery
    testQueryString = '.media-gallery:not([data-js-parsed--media-gallery])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "media-gallery");
        import('./modules/media-gallery/media-gallery.js').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // select-radio-on-focus
    testQueryString = '.select-radio-on-focus:not([data-js-parsed--select-radio-on-focus])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "select-radio-on-focus");
        import('./js/select-radio-on-focus').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // form number control
    testQueryString = '.form-number-control:not(.readonly):not([data-js-parsed--form-number-control])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "form-number-control");
        import('./js/form-number-control').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // text-input-force-numeric
    testQueryString = '.text-input-force-numeric:not(.readonly):not([data-js-parsed--text-input-force-numeric])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "text-input-force-numeric");
        import('./js/text-input-force-numeric').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // form-check enable target
    testQueryString = 'input[data-form-check-enable-target]:not([data-js-parsed--form-check-enable-target])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "form-check-enable-target");
        import('./js/form-check-enable-target').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // custom-date-picker
    testQuery = document.querySelector('input[data-custom-date-picker]:not([data-js-parsed--custom-date-picker])');
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll('input[data-custom-date-picker]:not([data-js-parsed--custom-date-picker])');
        addDataJsParsed(thisDomQuery, "custom-date-picker");
        import('./js/custom-date-picker').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // radio-collapse-control
    testQueryString = '.radio-collapse-control:not([data-js-parsed--radio-collapse-control])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "radio-collapse-control");
        import('./js/radio-collapse-control').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // video-embed options
    testQueryString = 'iframe.video-embed[data-autoplay-on-enter]:not([data-js-parsed--video-embed]), iframe.video-embed[data-mute-sound]:not([data-js-parsed--video-embed])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "video-embed");
        import('./js/video-embed').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    // membership-details-groups
    testQueryString = '.membership-details-groups:not([data-js-parsed--membership-details-groups])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "membership-details-groups");

        function onValidated() {
            const form = document.getElementById('membership-details-form');
            const details = form.querySelectorAll('.membership-details-group--item');
            const allValid = Array.from(details).every(function (detail) {
                if (!detail.classList.contains('editable')) {
                    return true;
                }
                return detail.classList.contains('validated');
            });
            if (allValid) {
                document.querySelector('.membership-details-groups--continue-btn').disabled = false;
            }
            else {
                document.querySelector('.membership-details-groups--continue-btn').disabled = true;
            }
        }

        function validateEmail(email) {
            return email.match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        };

        function validateMemberDetails(details) {
            const address = details.obj.el.querySelector('#manual-address-entry');
            if (address) {
                const collapse = Collapse.getOrCreateInstance(address, { toggle: false });

                collapse.show();
            }
            const inputs = details.obj.el.querySelectorAll('input, select');
            const allValid = Array.from(inputs).every(function (input) {
                if (input.type === 'email') {
                    return validateEmail(input.value)
                }
                const valid = input.value !== '';
                return valid;
            });
            if (allValid) {
                return true;
            }
            const form = document.getElementById('membership-details-form');
            if(form != null) {
                if (window.validationService.isValid(form)) {
                    return true;
                }
                window.validationService.validateForm(form);
                return false;
            }
        }

        if (testQuery.dataset.live === 'True') {
            import(
                /* webpackMode: "lazy" */
                './js/membership-details-groups'
            ).then((js) => {
                js.createFrom(thisDomQuery, validateMemberDetails, onValidated);
            });
        } else {
            import(
                /* webpackMode: "lazy" */
                './js/membership-details-groups'
            ).then((js) => {
                js.createFrom(thisDomQuery);
            });
        }
    }

    // tripadvisor icon shiv
    testQueryString = '.fa-tripadvisor:not([data-js-parsed--fa-tripadvisor])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fa-tripadvisor");
        import(
            /* webpackMode: "lazy" */
            './js/tripadvisor-icon-shiv'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }
    
    // tiktok icon shiv
    testQueryString = '.fa-tiktok:not([data-js-parsed--fa-tiktok])';
    addQuickCheckQuery(testQueryString);
    testQuery = document.querySelector(testQueryString);
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll(testQueryString);
        addDataJsParsed(thisDomQuery, "fa-tiktok");
        import(
            /* webpackMode: "lazy" */
            './js/tiktok-icon-shiv'
        ).then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

    //Order history filter
    testQuery = document.querySelector('.account--orders-listing:not([data-js-parsed--account--orders-listing])');
    if (testQuery != null) {
        let thisDomQuery = document.querySelectorAll('.account--orders-listing:not([data-js-parsed--account--orders-listing])');
        addDataJsParsed(thisDomQuery, "account--orders-listing");
        import('./js/order-history-filter').then((js) => {
            js.createFrom(thisDomQuery);
        });
    }

};

const calendarBookingElements = document.querySelectorAll('.js-calendar-booking');

if (calendarBookingElements.length) {
    import('./js/calendarBookingApi').then(({ default: CalendarBookingApi }) => {
        calendarBookingElements.forEach(calendarBookingElement => {
            new CalendarBookingApi(calendarBookingElement);
        });
    });
}

// create a mutation observer to watch for dynamically added HTML

let checkRequested = false, checkTimeout = null;

// run a check on page load
jsModuleCheck();

// Select the node that will be observed for mutations
const targetNode = document.querySelector('body');
if(targetNode != null) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
        // Use traditional 'for loops' for IE 11
        let checkNeeded = false;
        for(const mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                checkNeeded = true;
            }
        }
        if(checkNeeded && !checkRequested) {
            checkRequested = true;
            clearTimeout(checkTimeout);
            checkTimeout = setTimeout(() => {
                jsModuleQuickCheck();
                checkRequested = false;
            }, 100);
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    setTimeout(() => {
        // do another check now
        jsModuleQuickCheck();
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }, 3000);
}